module.exports = __webpack_public_path__ + "static/media/programa_publico_barrendero.b575a613.jpg";